import get from "lodash-es/get";

// These are borrowed from src/util/helpers.ts in the vuetify release. They allow us to leverage Vuetify's item property
// fetching logic in our own components.

export type VuetifyPropertyArg =
  | string
  | (string | number)[]
  | ((item: any, fallback?: any) => any);

export function getNestedValue(
  obj: any,
  path: (string | number)[],
  fallback?: any
): any {
  const last = path.length - 1;

  if (last < 0) return obj === undefined ? fallback : obj;

  for (let i = 0; i < last; i++) {
    if (obj == null) {
      return fallback;
    }
    obj = obj[path[i]];
  }

  if (obj == null) return fallback;

  return obj[path[last]] === undefined ? fallback : obj[path[last]];
}

export function getObjectValueByPath(
  obj: any,
  path: string,
  fallback?: any
): any {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (obj == null || !path || typeof path !== "string") return fallback;
  if (obj[path] !== undefined) return obj[path];
  path = path.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  path = path.replace(/^\./, ""); // strip a leading dot
  return getNestedValue(obj, path.split("."), fallback);
}

export function getPropertyFromItem(
  item: object,
  property:
    | string
    | (string | number)[]
    | ((item: object, fallback?: any) => any),
  fallback?: any
): any {
  if (property == null) return item === undefined ? fallback : item;

  if (item !== Object(item)) return fallback === undefined ? item : fallback;

  if (typeof property === "string")
    return getObjectValueByPath(item, property, fallback);

  if (Array.isArray(property))
    return property.map((p) => get(item, p, fallback));

  if (typeof property !== "function") return fallback;

  const value = property(item, fallback);

  return typeof value === "undefined" ? fallback : value;
}
